// extracted by mini-css-extract-plugin
export var arboretumhero = "ArboretumHero-module--arboretumhero--74299";
export var content = "ArboretumHero-module--content--99a7f";
export var contentBackground = "ArboretumHero-module--contentBackground--b2ef0";
export var contentCategory = "ArboretumHero-module--contentCategory--4aee4";
export var contentContainer = "ArboretumHero-module--contentContainer--16767";
export var contentContainerWrap = "ArboretumHero-module--contentContainerWrap--a8504";
export var imageContainer = "ArboretumHero-module--imageContainer--32e2e";
export var imageContainerWrap = "ArboretumHero-module--imageContainerWrap--f263e";
export var kontentImageContainer = "ArboretumHero-module--kontentImageContainer--a199b";
export var tall = "ArboretumHero-module--tall--228e7";
export var text = "ArboretumHero-module--text--ef0ca";
export var xshort = "ArboretumHero-module--xshort--95891";